module.exports = __webpack_public_path__ + "static/image/audience-guide4.svg?5bcfa204bd6aa3d54e2c031793f447f8";